import React from 'react';
import { FullBackground } from '../../../components/FullBackground';
import { getImageSrc } from '../../../util';

type Props = {
  className?: string;
};

const ProductOrderPay: React.FC<Props> = ({ className }) => {
  return (
    <>
      <FullBackground color={'bg-gray-900'}>
        <div
          style={{ marginLeft: '50vw', marginRight: '50vw' }}
          className={className}
          id={'order-pay'}
        >
          <div className="py-16 lg:py-24">
            <div className="relative max-w-xl max-w-7xl">
              <div className="relative mt-32 mb-32 lg:mt-32 lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
                <div className="mt-10 lg:mt-0 relative" aria-hidden="true">
                  <div className="relative py-3 w-3/4 lg:w-full mx-auto md:mx-0">
                    {/*<div className="absolute px-4 py-10 bg-white shadow-lg rounded-2xl sm:rounded-3xl sm:p-20 bg-primary-600" />*/}
                    <div className={'relative    lg:1/5 md:3/4 xl:w-4/5  '}>
                      <picture>
                        <source
                          srcSet={getImageSrc('webqrset.webp')}
                          type="image/webp"
                        />
                        <source
                          srcSet={getImageSrc('webqrset.png')}
                          type="image/png"
                        />
                        <img
                          className="transform scale-75"
                          src={getImageSrc('webqrset.webp')}
                          alt={'QR Codes'}
                        />
                      </picture>
                    </div>
                  </div>
                </div>
                <div className="relative">
                  <div className="max-w-3xl  text-left">
                    <h2 className="text-base text-primary-600 font-semibold tracking-wide uppercase">
                      Dynamic QR Codes
                    </h2>
                    <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl">
                      Best on the block.
                    </p>

                    <div className="text-xl text-white lg:mx-auto my-4">
                      <p>
                        TableTab QR codes connect guests to your digital menu
                        and any other destination you can imagine. Our dashboard
                        will automatically generate and maintain them for you.
                      </p>
                    </div>
                  </div>
                  <dl className="mt-10 space-y-10">
                    <div className="flex">
                      <div className="">
                        <dd className="mt-2 text-base text-white ">
                          <ul className="space-y-4">
                            <li className="flex space-x-3">
                              <div
                                className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-primary-100 text-white"
                              >
                                <svg
                                  className="flex-shrink-0 h-4 w-4 text-primary-600"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <span className="text-base text-white">
                                Dynamic QR codes with unlimited scans that never
                                expire
                              </span>
                            </li>

                            <li className="flex space-x-3">
                              <div
                                className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-primary-100 text-white"
                              >
                                <svg
                                  className="flex-shrink-0 h-4 w-4 text-primary-600"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <span className="text-base text-white">
                                Generate as many QR codes as you like
                              </span>
                            </li>

                            <li className="flex space-x-3">
                              <div
                                className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-primary-100 text-white"
                              >
                                <svg
                                  className="flex-shrink-0 h-4 w-4 text-primary-600"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <span className="text-base text-white">
                                Easily assign a QR code to a table and reassign
                                at will
                              </span>
                            </li>
                            <li className="flex space-x-3">
                              <div
                                className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-primary-100 text-white"
                              >
                                <svg
                                  className="flex-shrink-0 h-4 w-4 text-primary-600"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <span className="text-base text-white">
                                Download QR codes from the dashboard to print or
                                share
                              </span>
                            </li>
                            <li className="flex space-x-3">
                              <div
                                className="flex items-center justify-center h-5 w-5 rounded-full
                                                    bg-primary-100 text-white"
                              >
                                <svg
                                  className="flex-shrink-0 h-4 w-4 text-primary-600"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                  fill="currentColor"
                                  aria-hidden="true"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                    clipRule="evenodd"
                                  />
                                </svg>
                              </div>
                              <span className="text-base text-white">
                                Access QR code URL as another access point to
                                destination
                              </span>
                            </li>
                          </ul>
                        </dd>
                      </div>
                    </div>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FullBackground>
    </>
  );
};

export default ProductOrderPay;
